export default __webpack_public_path__ + "static/media/thorchain.e516d8ee.png";